import React from 'react';
interface AvatarProps {
  src?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  hasStory?: boolean;
}
export function Avatar({
  src,
  alt = 'Avatar',
  size = 'md',
  className = '',
  hasStory = false
}: AvatarProps) {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-24 h-24'
  };
  const storyRing = hasStory ? 'p-0.5 border-2 border-primary' : '';
  return <div className={`relative rounded-full overflow-hidden bg-surface flex items-center justify-center shrink-0 ${sizes[size]} ${storyRing} ${className}`} data-id="element-194">
      {src ? <img src={src} alt={alt} className="w-full h-full object-cover rounded-full" data-id="element-195" /> : <div className="w-full h-full bg-gradient-to-br from-surface2 to-border rounded-full flex items-center justify-center text-softGray font-bold" data-id="element-196">
          {alt.charAt(0).toUpperCase()}
        </div>}
    </div>;
}